import { shadows, breakpoints, colors } from '@web-for-marketing/react-ui';
import { ColumnCount, TestimonialBackgroundColor } from '@models/column';

const testimonialBackgrounds = {
    [TestimonialBackgroundColor.Gray]: colors.background.light,
    [TestimonialBackgroundColor.White]: colors.background.white,
};

export const testimonialStyles = {
    testimonialBackground: (color?: TestimonialBackgroundColor) => ({
        backgroundColor: testimonialBackgrounds[color || TestimonialBackgroundColor.Gray],
        boxShadow: color === TestimonialBackgroundColor.White ? shadows.hard : undefined,
        padding: '2.4rem',
        borderRadius: '8px',
    }),
    ratingContainer: {
        marginBottom: '1.6rem',
    },
    linkContainer: {
        marginTop: '2.4rem',
    },
    testimonialLink: {
        color: colors.text.activePrimary,
        fontWeight: 500,
        borderRadius: '8px',
        padding: '0.8rem 1.6rem',
        marginLeft: '-1.6rem',
        '&:hover': {
            backgroundColor: colors.action.active,
            textDecoration: 'none',
        },
        '&:focus': {
            backgroundColor: colors.action.active,
            color: colors.text.activeSecondary,
            outline: 'none',
        },
    },
    linkText: {
        textDecoration: 'underline',
    },
    portrait: {
        width: '8rem',
        height: '8rem',
        borderRadius: '50%',
        marginBottom: '2rem',
        [`@media (max-width: ${breakpoints.md})`]: {
            marginBottom: 0,
        },
    },
    profileContainer: (direction?: 'Left' | 'Right', columnCount?: ColumnCount) => ({
        maxWidth: columnCount === 3 ? '100%' : '30rem',
        width: columnCount === 3 ? '100%' : undefined,
        marginRight: direction !== 'Right' && columnCount !== 3 ? '2.4rem' : undefined,
        marginLeft: direction === 'Right' && columnCount !== 3 ? '2.4rem' : undefined,
        marginBottom: columnCount === 3 ? '1.6rem' : undefined,
        [`@media (max-width: ${breakpoints.lg})`]: {
            width: columnCount === 2 ? '100%' : undefined,
            maxWidth: columnCount === 2 ? '100%' : undefined,
            marginBottom: columnCount === 2 ? '1.6rem' : undefined,
            marginRight: columnCount === 2 ? 0 : undefined,
            marginLeft: columnCount === 2 ? 0 : undefined,
        },
        [`@media (max-width: ${breakpoints.md})`]: {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            maxWidth: '100% !important',
            marginBottom: '1.6rem',
            marginLeft: '0 !important',
            marginRight: '0 !important',
        },
    }),
    content: {
        flex: 1,
    },
    profileInfo: (columnCount?: ColumnCount) => ({
        maxWidth: columnCount === 3 ? '30rem' : '100%',
        [`@media (max-width: ${breakpoints.lg})`]: {
            maxWidth: columnCount === 2 ? '30rem' : undefined,
        },
        [`@media (max-width: ${breakpoints.md})`]: {
            maxWidth: '30rem !important',
            marginLeft: '2rem',
        },
    }),
    quoteIcon: {
        color: colors.core.haze,
        width: '2.4rem',
        height: '2.4rem',
    },
    newTabIcon: {
        verticalAlign: 'text-top',
        width: '1em',
        height: '1em',
        '& path': {
            fill: 'currentColor',
        },
    },
} as const;
